import Layout from "../../components/Layout/Layout";
import React, { useState } from 'react'
import * as RiIcons from "react-icons/ri";
import ModuleServices from "../../services/ModuleServices";
import { useEffect } from 'react';
import RoleServices from "../../services/RoleServices";
import async from './../../utils/TenantCall';
import fire from './../../utils/Toastr';

export default function UpdateRole() {
    const roleName = new URLSearchParams(window.location.search).get("id");
    const [open, setOpen] = useState(false);
    const [role, setRole] = useState([]);
    const [module, setModule] = useState([]);
    const [formValues, setFormValues] = useState({
        name: ""
    })
    const handleOpen = () => {
        if (open === true) {
            setOpen(false);
        } else if (open === false)
            setOpen(true);
    };
    const viewRole = async () => {
      
        const view = await RoleServices.viewRole(roleName)
        const checked = view.data.moduleAssigned;
        const newCheck = checked.split(",");
        setRole(newCheck);
    }
    const listModuleds = async () => {
        const module = await ModuleServices.listModules();
        setModule([...module.data]);

    }
    const handleChange = async (evt) => {
        const value =
            evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
        let temp = role;

        if (evt.target.checked === false) {
            var tester = temp.findIndex(e => e === evt.target.value);

            temp.splice(tester);


        } else {
            temp.push(evt.target.value);

        }
        var assigned = [...temp];
        var newMod = assigned.join()
        setFormValues({
            ...formValues,
            name: [...temp]
        });
    }
    const update = async (e) => {
        e.preventDefault();
        const resp = await RoleServices.updateRole({
            moduleAssigned:formValues.name.join(),
            roleName:roleName
        });
        if (resp) {
            fire("success", resp.message);
        setTimeout(() => {
            window.location.reload();
        }, 3000);          
        }
       
    }
    useEffect(() => {
        viewRole();
        listModuleds();
    }, [])
    return (<Layout title={'Roles'} pageTag={'admin'} current={'/roles'}>
        <main>
            <div className='max-w-7xl w-2/3 '>
                <div className='inline w-2/3 py-2 align-middle md:px-6 lg:px-8 bg-white'>
                    {/* form */}
                    <form className='px-6'>
                        <div className='mt-6 '>
                            <div className="">
                                <label htmlFor="roleName" className="block text-sm font-medium text-gray-700 mb-2">
                                    Name
                                </label>
                                <div className="mt-1">
                                    <input
                                        type="text"
                                        name="roleName"
                                        value={roleName}
                                        id="roleName"
                                        autocomplete="given-name"
                                        placeholder="Enter role name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                </div>
                            </div>


                            <div className="mt-5">
                                <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                    Modules Available
                                </label>
                                <button className="btn-secondary border w-full flex p-2 justify-between rounded-md" onClick={handleOpen} type="button">
                                    <span className="text-gray-500 text-sm"> Select modules for this role</span>
                                    <span className="text-base">
                                        <RiIcons.RiArrowDownSLine className="w-6 h-4 text-base" />

                                    </span>
                                </button>
                                <div className="mt-5">
                                    <fieldset className="space-y-5">
                                        {module.map((mod, i) => (
                                            <>
                                                <div className="relative flex items-start">
                                                    <div className="flex items-center h-5">
                                                        <input
                                                            id="name"
                                                            aria-describedby="comments-description"
                                                            name="name"
                                                            type="checkbox"
                                                            value={mod.moduleTag}
                                                            checked={role.includes(mod.moduleTag)}
                                                            onChange={(e) => handleChange(e)}
                                                            className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                        />
                                                    </div>
                                                    <div className="ml-3 text-sm">
                                                        <label htmlFor="name" value={formValues.name}
                                                            className="font-medium text-gray-700">
                                                            {mod.moduleName}
                                                        </label>
                                                    </div>
                                                </div>
                                            </>
                                        ))}

                                    </fieldset>
                                </div>

                            </div>
                        </div>
                        <div className='mt-4 flex justify-end'>
                            <button
                                onClick={() => window.location.reload(true)}
                                type='submit'
                                className='btn-sec hover:text-white focus:text-white mr-2 bg-gray-100 text-gray-900 inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium  shadow-sm  sm:w-auto'>
                                Reset
                            </button>
                            <button type='submit'
                                onClick={update} className='btn-primary text-white inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto'>
                                Update
                            </button>

                        </div>
                    </form>

                </div>
            </div>
        </main>
    </Layout>)
}